import React from 'react';
import { Card, Notification, Column } from "rbx";
import PurchaseSummary from './PurchaseSummary';
import { payMethodsList } from '../../commons/constants';
import AppService from '../../services/app';
import PdvService from '../../services/pdv';
import Controls from './Controls/Controls';
import useForm from './useForm';

const AddCadForm = ({ setMessage, goToMenu, userApp=false, userPdv=false }) => {
  const user = JSON.parse(sessionStorage.getItem( userApp ? 'app' : 'pdv' ));
  const UserService = userApp ? AppService : PdvService;
  const userType = userApp ? 1 : 2;

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm({userType: userType, cpf_cnpj: user.cpf_cnpj, quantity: '', paymentMethod: ''});

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    setStatus('');
    try {
      const response = await UserService.addCads(values);
      await UserService.findByCpf(values.cpf_cnpj);
      setMessage(['success', response.data.message]);
      goToMenu();
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>Inserir CADs</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Column.Group>
            <Column className="has-text-left">
              <Controls.TextField 
                label="Informe a quantidade de CADs"
                name="quantity"
                placeholder='100'
                value={values.quantity}
                onChange={handleInputChange}
                required
                maxLength="4"
                className="has-text-right"
                focus={true}
              />
              <Controls.SelectField
                label="Forma de Pagamento"
                name="paymentMethod"
                value={values.paymentMethod}
                onChange={handleInputChange}
                options={payMethodsList}
                required
              />
             </Column>
            <Column>
              <PurchaseSummary quantity={values.quantity} discount={user.discount||0} />
            </Column>
          </Column.Group>
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Inserir'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default AddCadForm;
